/// ////////////////////////////////////////////////////////////
/// ////////////////////// English /////////////////////////////
/// ////////////////////////////////////////////////////////////
import React from "react";

import { DASH_LINKS } from "@const/AppCardLinks";

export const data: Record<string, React.ReactNode> = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <strong>EngagED Parent Portal Login Process (Internal/External)</strong>,
    Interrupt_p1: (
        <>
            To log in to the EngagED Parent Portal, you will pair your{" "}
            <strong>Infinite Campus Parent Portal username</strong>
            (external parent: username you created during account setup) <u>and</u> <strong>@p.dcsdk12.org</strong>. For
            example: if your Infinite Campus username is <strong>jsmith</strong>, you will enter{" "}
            <strong>jsmith@p.dcsdk12.org</strong> as your email address on the login screen that follows. Your{" "}
            <strong>password</strong> is the same one you use for accessing Infinite Campus (external parent: password
            you created during account setup).
        </>
    ),
    Interrupt_p2: (
        <>
            <strong>If you have forgotten your DCSD login credentials</strong>:<br />
            Use these links to
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/forgotuserid.jsf"
                rel="noreferrer"
                target="_blank"
            >
                retrieve your username
            </a>{" "}
            and/or{" "}
            <a
                href="https://iaas5idm.fischeridentity.com/identity/self-service/dcs/kiosk.jsf"
                rel="noreferrer"
                target="_blank"
            >
                reset your password
            </a>
            {"."}
        </>
    ),
    Interrupt_p3: (
        <>
            <strong>If you have followed the steps above and continue to have difficulty, please contact us</strong>
            :<br />
            <a href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT" rel="noreferrer" target="_blank">
                Parent Tech Support - English
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                target="_blank"
            >
                Parent Tech Support - Spanish
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                target="_blank"
            >
                Parent Tech Support - Chinese
            </a>
            <br />
            IT Support Center at <strong>303.387.0001</strong>
        </>
    ),
    Interrupt_note:
        "NOTE: District employees who are current parents should follow the instructions above using an incognito or private browser window and/or different browser.",
    Interrupt_submit: "Proceed to Login",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Welcome,",
    Main_Nav_HelpfulLinks: "Helpful Links",
    Main_Nav_LogOut: "LOGOUT",
    Main_Nav_HelpfulLinks_LI_s1: "Contact My Student(s) Nurse",
    Main_Nav_HelpfulLinks_LI_s2: "Academic Calendars",
    Main_Nav_HelpfulLinks_LI_s3: "Parent Resources",
    Main_Nav_HelpfulLinks_LI_s4: "Bus Routes",
    Main_Nav_HelpfulLinks_LI_s5: "Online Payments",
    Main_Nav_HelpfulLinks_LI_s6: "Lunch Menus",
    Main_Nav_Exit: "EXIT",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Add",
    Global_Add_New_Student: "Add New Student",
    Global_Add_New_Student_For_Open_Enrollment: "Add New Student For Open Enrollment",
    Global_BackToDashboard: "Back to Dashboard",
    Global_Dashboard: "Dashboard",
    Global_Faq: "FAQ",
    Global_Close: "Close",
    Global_Completed: "Completed",
    Global_Currently_Unavailable: "Currently Unavailable",
    Global_InProgress: "In Progress",
    Global_GoTo: "Go To",
    Global_Loading: "Please wait while we gather your student's information ...",
    Global_MoreInfo: "More Info",
    Global_No_Student_1: "Welcome to the EngagED Parent Portal",
    Global_No_Student_2: "Sorry, we are unable to find any students associated to your account.",
    Global_No_Student_External: (
        <>
            If you are applying for Open Enrollment, please click the &ldquo;<strong>Add New Student</strong>&rdquo;
            button to add your student. If you are applying for multiple students, you will add each student
            individually.
        </>
    ),
    Global_No_Student_Guardian: (
        <>
            If you do not see your student(s) and they are currently enrolled in a DCSD school, please contact the IT
            Support Center at <strong>303-387-0001</strong>. Please only use the &ldquo;{""}
            <strong>Add New Student</strong>&rdquo; button to add your student if they are not currently enrolled in a
            DCSD school and you are applying for Open Enrollment.
        </>
    ),
    Global_Notice_Ae: "Assessment Excusals will be available", // <some date>
    Global_Notice_Bus: "Transportation will be available", // <some date>
    Global_Notice_Check_Back: "Please check back later.",
    Global_Notice_Oe: "Open Enrollment will be available", // <some date>
    Global_NotStarted: "Not Started",
    Global_Open: "Open",
    Global_OpenFrom: "Open From", // <some date> - <some date>
    Global_Status: "Status",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD Guardian Dashboard",
    Breadcrumb_Back: "DCSD EngagED Parent Portal",
    Breadcrumb_EPR: "DCSD Archived EPRs",
    Breadcrumb_Translations: "Translations are experimental",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Broadcast ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Broadcast_Title: "Looking Ahead:",
    Broadcast_Message: (
        <>
            Please be advised that all DCSD parent tools, including Open Enrollment, will be offline/unavailable on{" "}
            <strong>Saturday, November 22</strong> and <strong>Sunday, November 23</strong> while the DCSD IT team
            completes a critical data center migration.
        </>
    ),

    /// /////////////////////////////////////////////////////////
    /// /////////////////// EPR /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    EPR_Failure1: "Sorry, we are unable to retrieve the EPR PDF for the student",
    EPR_Failure2: "Please provide the following information when contacting the district for support:",
    EPR_NoData: "No historical EPRs found for the student.",
    EPR_Success: "EPR PDF retrieved successfully for the student.",
    EPR_Title: "Archived EPR Resources",
    /// /////////////////////////////////////////////////////////
    /// /////////////////// No Apps /////////////////////////////
    /// /////////////////////////////////////////////////////////
    NoApp_Body1: "All application windows are currently closed.",
    NoApp_Body2: "If you feel this is in error, please contact the district for support.",
    NoApp_Closed: "Closed",
    NoApp_Header: "No Applications Available",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Welcome Page ////////////////////////////
    /// /////////////////////////////////////////////////////////
    Welcome_Header: "Welcome to the DCSD Guardian Dashboard",
    Welcome_Header_Alt: "Welcome to the EngagED Parent Portal",
    Welcome_Tagline: "Partnering with parents to select the best learning environment for every student.",
    Welcome_p1: (
        <p className="grey-text">
            We empower families to find the best educational fit for their children.{" "}
            <a
                href="https://www.dcsdk12.org/schools-academics/schools/school-locator-map"
                rel="noreferrer"
                target="_blank"
            >
                Learn More
            </a>
        </p>
    ),
    Welcome_p2: (
        <p className="grey-text">
            Families who wish to enroll their student in a school other than their neighborhood school must use this
            tool to request Open Enrollment during one of two open enrollment periods DCSD offers annually.{" "}
            <span className="highlight">
                You do not need to use this open enrollment tool to stay at your school of{" "}
                <strong>current enrollment</strong>.
            </span>
        </p>
    ),
    Welcome_h5_1: (
        <h5 className="grey-text">
            <a
                href="https://docs.google.com/document/d/1sr3ARzZGUmmJdNSjlWnLM0QWj8ipKHJb3RkwLr72_P0/edit"
                rel="noreferrer"
                target="_blank"
            >
                Click here
            </a>{" "}
            for step by step instructions on how to use the tool.
        </h5>
    ),
    Welcome_ImportantDates: "Important Dates/Times",
    Welcome_FirstWindow: "First Window",
    Welcome_SecondWindow: "Second Window",
    Welcome_ul_li1a: "First round open enrollment is NOT first-come, first-served; you have until", // <some date>
    Welcome_ul_li1b: "to complete this process.",
    Welcome_ul_li2a: "For first round, you can change your open enrollment request choices at any time until", // <some date>
    Welcome_ul_li3: "Schools will make offers to families based on space availability.",
    Welcome_ul_li4a: "Offers will not be visible to you until after", // <some date>
    Welcome_ul_li4b: (
        <>
            You can log back into <a href={DASH_LINKS.guardian}>EngagED Parent Portal</a> on or after
        </>
    ), // <some date>
    Welcome_ul_li4c: "to check on any offers you may have received.",
    Welcome_ul_li5a: "You have until", // <some date>
    Welcome_ul_li5b: (
        <>
            to accept an open enrollment offer from a school through the{" "}
            <a href={DASH_LINKS.guardian}>EngagED Parent Portal</a>.
        </>
    ),
    Welcome_ul_li6a:
        "If your open enrollment request is not accepted by any school, or you didn't log in and accept your offer, you will automatically be placed on the second round open enrollment waitlist, which runs from", // <some date range>
    Welcome_Before_You_Begin: "BEFORE YOU BEGIN",
    Welcome_Before_You_Begin_Body: (
        <>
            <div className="grey-text">
                <strong>
                    If your son or daughter has ever attended a DCSD school, you already have a Parent Portal account
                    username and password. Please{" "}
                    <span className="danger">
                        <strong>DO NOT</strong>
                    </span>{" "}
                    create a new account as this will potentially impact your student&apos;s open enrollment. If you
                    have forgotten your Parent Portal account information, please contact your current DCSD school or
                    the office of Choice Programming to access parent portal.
                </strong>
            </div>
            <h5 className="mt-3">Attention Parents/Guardians:</h5>
            <div className="grey-text">
                The login process for accessing the EngagED Parent Portal has recently changed.{" "}
                <strong>
                    Parents/guardians must now add <strong>@p.dcsdk12.org</strong> after their current username when
                    logging into the EngagED Parent Portal
                </strong>
                {". "}
                For example, if you have previously accessed with a username of absmith, you will now use
                absmith@p.dcsdk12.org for your username along with your district password which has not changed.
            </div>
            <div className="grey-text mt-3">
                If you need to change your district password and/or manage your account, you can do so on the DCSD
                website{" "}
                <a
                    href="https://www.dcsdk12.org/parents-students/resources/parent-it-support/password-reset"
                    rel="noreferrer"
                    target="_blank"
                >
                    here
                </a>
                . If you run into difficulty logging in to EngagED using the new login process outlined above, please
                contact the DCSD IT Department by clicking{" "}
                <a
                    href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                    rel="noreferrer"
                    target="_blank"
                >
                    here
                </a>
                {", "}
                or calling 303-387-0001.
            </div>
        </>
    ),
    Welcome_InfoFooter: (
        <>
            <em>
                For more information, please contact the office of <strong>Choice Programming</strong> at
            </em>{" "}
            <a href="mailto:open-enrollmentusergroup@dcsdk12.org">open-enrollmentusergroup@dcsdk12.org</a>.
        </>
    ),
    Welcome_NotAvailable: "Open Enrollment process for the current school year is not yet available.",
    Welcome_PreschoolInfo: "Kindergarten/Preschool Information",
    Welcome_Note: "NOTE",
    Welcome_NoSupport: "This application does not support applying to DCSD preschools.",
    Welcome_PreschoolsLink: (
        <>
            For DCSD preschools,{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/preschool" rel="noreferrer" target="_blank">
                <strong>click this link</strong>
            </a>
            {"."}
        </>
    ),
    Welcome_PreschoolEnrollment: (
        <>
            Parents wishing to enroll their three & four year olds in district preschools do not go through open
            enrollment. Preschool registration will take place in early January. Follow this{" "}
            <a href="https://www.dcsdk12.org/schools-academics/schools/kindergarten" rel="noreferrer" target="_blank">
                <strong>link</strong>
            </a>{" "}
            for more information.
        </>
    ),
    Welcome_CharterSchoolInfo: "Charter School Information",
    Welcome_CharterSchoolInclude: (
        <>
            <h5>The following Charter Schools will be utilizing the tool this year:</h5>
            <a
                href="https://www.dcsdk12.org/schools_academics/schools/charter_schools"
                rel="noreferrer"
                target="_blank"
            >
                <u>
                    Please contact all other Charter schools directly to learn more about enrollment options for charter
                    schools.
                </u>
            </a>
            <ul className="charter-school-li">
                <li>
                    <em>Aspen View Academy</em>
                </li>
                <li>
                    <em>Ben Franklin Academy</em>
                </li>
                <li>
                    <em>Challenge to Excellence</em>
                </li>
                <li>
                    <em>DCS Montessori Charter</em>
                </li>
                <li>
                    <em>Leman Academy of Excellence</em>
                </li>
                <li>
                    <em>Parker Performing Arts School</em>
                </li>
                <li>
                    <em>Platte River Academy</em>
                </li>
                <li>
                    <em>SkyView Academy</em>
                </li>
                <li>
                    <em>World Compass Academy</em>
                </li>
            </ul>
        </>
    ),
    Welcome_TransportationInfo: "Transportation Information",
    Welcome_TransportationBody:
        "Transportation for resident students granted permission to attend a school or program outside their neighborhood attendance area shall be furnished by their parent/guardian.",
    Welcome_GeneralInfo: "General Information",
    Welcome_GeneralInfo_ul2_li1: "A confirmation email will be sent to you after your request has been submitted.",
    Welcome_GeneralInfo_ul2_li3: (
        <>
            Second round open enrollment is &ldquo;first come first served.&rdquo; Students requesting open enrollment
            only in the second round are placed on the waitlist behind those that are currently on the waitlist from
            first round.
        </>
    ),
    Welcome_GeneralInfo_ul2_li4: (
        <>
            If you are open enrolled at a neighborhood school or attend a charter but would like to return to the
            neighborhood school associated with your address for the next school year you must file an{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                intent to return form
            </a>{" "}
            <strong>by</strong>
        </>
    ), // <some date>,
    Welcome_GeneralInfo_li5: (
        <>
            If you are moving within the district but would like to remain at your current school, you may do so by
            filing an{" "}
            <a
                href="https://www.dcsdk12.org/about/departments/choice-programming/forms"
                rel="noreferrer"
                target="_blank"
            >
                intent to remain
            </a>{" "}
            form at any time.
        </>
    ),
    Welcome_Start_Here: "Start Here",
    Welcome_New_To_District: "Are you new to the district?",
    Welcome_No: "No",
    Welcome_Yes: "Yes",
    Welcome_U_And_P: "Do you have a username and password for the EngagED Parent Portal?",
    Welcome_Log_In: "Log In",
    Welcome_Contact_Choice_Programming:
        "Please contact the student's current school for assistance with DCSD parent portal account creation.",
    Welcome_Create_Account: "Create New Account",
    Welcome_Caution:
        "* Caution: If you currently have a student in the district but are having trouble logging in to the EngagED Parent Portal, DO NOT create a new account, as this may make your open enrollment request VOID! Please contact your current DCSD school or the office of Choice Programming if you need help logging into your current EngagED parent portal account.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Marquee /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Marquee_Grade: "Grade",
    Marquee_School: "School",
    Marquee_Address: "Address",
    Marquee_NewStudent: "New Student",
    Marquee_NotAvailable: "Not Available",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment App /////////////////////
    /// /////////////////////////////////////////////////////////
    OEApp_Header: "Open Enrollment",
    OEApp_Btn1: "Start Open Enrollment",
    OEApp_Btn2: "Manage School Choices",
    OEApp_Btn3: "View Student Info",
    OEApp_Btn4: "Edit Student Info",
    OEApp_Btn5: "Select School Choices",
    OEApp_Btn6: "Go to Open Enrollment",
    OEApp_Btn7: "View School Choices",
    OEApp_Btn8: "View School Offer Status",
    OEApp_Btn9: "View School Offers",
    OEApp_Schools: "School Choices Made",
    OEApp_School: "School Choice Made",
    OEApp_NoSchools: "No School Choices Made",
    OEApp_1School: "1 School Choice Made",
    OEApp_MoreSchools: "School Choices Made",
    OEApp_SchoolsMakingOffers: "Schools Are Making Offers",
    OEApp_SchoolsFinalizingOffers: "Schools Are Finalizing Offers",
    OEApp_Body:
        "Application process for parents to elect enrollment consideration for their student(s) at DCSD neighborhood and charter schools.",
    OEApp_Round1: "Round 1",
    OEApp_Round2: "Round 2",
    OEApp_RoundClosed: "Round 1 closed. Please come back for Round 2 starting", // <some date>
    OEApp_SchoolChoices: "School Choices",
    OEApp_RequestStatus: "Request Status",
    OEApp_LanguageChoice: "Language Choice",
    OEApp_KinderChoice: "Kinder Choice",
    OEApp_LanguageOffer: "Language Offer",
    OEApp_KinderOffer: "Kinder Offer",
    OEApp_FullDay: "Full Day",
    OEApp_HalfDayPM: "Half Day PM",
    OEApp_HalfDayAM: "Half Day AM",
    OEApp_Spanish: "Spanish",
    OEApp_Mandarin: "Mandarin",
    OEApp_French: "French",
    OEApp_NotEligible: (
        <>
            Based on the student&apos;s birthdate, the{" "}
            <span className="age">student&apos;s age is outside the range for open enrollment</span>. Please contact the
            Choice Programming department to discuss the specific circumstances and/or options for open enrollment.
        </>
    ),
    OEApp_Ineligible: "Not Eligible",
    OEApp_NewStudent: "New Student",
    OEApp_ACCEPT_OFFER: "Accepted Offer",
    OEApp_CANCELLED_REQUEST: "Cancelled Request",
    OEApp_CHANGED_ENROLLMENT: "Unenrolled",
    OEApp_CHOICE_CREATED: "School Choice Created",
    OEApp_CHOICE_INCOMPLETE: "Choice Incomplete",
    OEApp_DENY_OFFER: "Denied Offer",
    OEApp_DENY_REQUEST: "Denied Request",
    OEApp_ENROLLED: "Enrolled",
    OEApp_INVALID: "Invalid",
    OEApp_MAKE_OFFER: "Offer Made",
    OEApp_MAKE_OFFER_PENDING: "Make Offer Pending",
    OEApp_NO_RESPONSE: "No Response",
    OEApp_WAIT_LIST: "On Wait List",
    OEApp_REQUEST: "Request Made",
    OEApp_UNENROLLED: "Unenrolled",
    OEApp_UNAVAILABLE: "Unavailable",
    /// /////////////////////////////////////////////////////////
    /// ///////////// Express Check-In App //////////////////////
    /// /////////////////////////////////////////////////////////
    ECApp_Header: "Express Check-In",
    ECApp_Btn1: "Go to Express Check-In",
    ECApp_Body:
        "Annual student check-in process for parents to update and/or verify current information for household address, media consent, emergency contacts, health conditions and much more.",
    /// ////////////////////////////////////////////////////////
    /// ///////// Elementary Progress Report App //////////////
    /// ////////////////////////////////////////////////////////
    EPRApp_Body: "Twice-annual academic progress information for neighborhood elementary school students.",
    EPRApp_NotReady:
        "Your student's Report Card isn't ready yet. Please contact your student's school for more information",
    EPRApp_NotReleased: "Not Released", // as in not available
    EPRApp_Coming_Soon: "Coming Soon",
    EPRApp_Available: "Report Card not available. Please come back starting ", // [some variable dateString]
    EPRApp_IsAvailable: "Report Card Available",
    EPRApp_NotAvailable: "Not Available",
    EPRApp_Header: "Elementary Report Card",
    EPRApp_Btn1: "View Most Recent Report Card",
    EPRApp_Btn2: "View Archived Report Cards",
    EPRApp_Semester: "Semester",
    EPRApp_1stSemester: "1st Semester",
    EPRApp_2ndSemester: "2nd Semester",
    EPRApp_SurveyLink: "Complete Parent EPR Survey",
    EPRApp_SurveyHeadline: "EPR Parent Survey",
    EPRApp_SurveyDescription: "Thank you in advance for providing feedback on your student's progress report.",
    /// ////////////////////////////////////////////////////////
    /// /////////// Assessment Excusals App ////////////////////
    /// ////////////////////////////////////////////////////////
    AEApp_Body: "Manage assessment opt-out requests.",
    AEApp_Header: "Assessment Excusals",
    AEApp_Excusal: "Excusal",
    AEApp_Excusals: "Excusals",
    AEApp_MoreExcusals: "Excusals",
    AEApp_NoExcusals: "No Excusals",
    AEApp_Btn1: "Go to Assessment Excusals",
    /// ////////////////////////////////////////////////////////
    /// /////////////// Transportation App /////////////////////
    /// ////////////////////////////////////////////////////////
    BusApp_Body1:
        "Each bus rider will present a valid bus pass to the driver. Ride fees will be billed quarterly per ride.",
    BusApp_Body2: "Apply for a buss pass.",
    BusApp_Header: "Transportation",
    BusApp_Btn1: "Go to Transportation",
    BusApp_BusPass: "Bus Pass Issued",
    BusApp_NotIssued: "No Bus Pass Issued",
    BusApp_NoBusPass: "You may request a bus pass and access more information about Transportation.",
    BusApp_NotRiding: "Not Riding",
    BusApp_NotRidingReason1: "You've indicated that", // <some student name>
    BusApp_NotRidingReason2: "will not be riding the bus this year.",
    BusApp_NotRidingReason3: "You've indicated that the student will not be riding the bus this year.",
    BusApp_Processing: "Bus Pass Processing",
    BusApp_AnnualOffer: "Annual Pass offer until", // <some date>
    BusApp_Annual: "In an earlier session you selected Annual Billing.",
    BusApp_Quarterly: "You have elected Quarterly Billing. You can opt into Annual Billing by", // <some date>
    BusApp_BusPassIssued: "Your student's bus pass has been issued.",
    BusApp_BusPassIssued2: (
        <>
            If a bus pass is damaged or has been lost, a replacement bus pass can be requested through{" "}
            <a
                className="anchor"
                href="https://www.onflo.com/Lets-Talk/FormBuilder/#/Dialogue?k=PG7KK3Z6DLT@WK3Z6DLT@MDLT@DY4N3T5LT@LDLT@NDLT"
                rel="noreferrer"
                target="_blank"
            >
                Onflo
            </a>
            {"."}
        </>
    ),

    BusApp_BusPassProcessing: "Your Bus Pass application is still processing. Please check back soon.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Loading Messages ////////////////////////
    /// /////////////////////////////////////////////////////////
    Loading_1: "Open Enrollment Loading",
    Loading_2: "Echeck-In Loading",
    Loading_3: "EPR Loading",
    Loading_4: "Assessment Excusals Loading",
    Loading_5: "Transportation Loading",
    Loading_6: "Survey Loading",
    Loading_7: "Broadcast Message Loading",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Open Enrollment Pending & Status ////////
    /// /////////////////////////////////////////////////////////
    OE_Pending_Desc_Pre: "Open Enrollment for the ",
    OE_Pending_Desc_Post:
        " school year has not yet opened. We invite prospective families and external guardians to explore DCSD schools and prepare for the upcoming enrollment window.",
    OE_Pending_Begins: "Open Enrollment begins on ",
    OE_Countdown_Opens_In: "Opens in ",
    OE_Countdown_Day: "day",
    OE_Countdown_Days: "days",
    OE_Explore_Schools_Title: "Explore DCSD Schools",
    OE_Explore_Schools_Desc:
        "Discover neighborhood, charter, and alternative school options across Douglas County School District to find the best learning environment for your student.",
    OE_Explore_Schools_Btn: "Explore School Options →",
    OE_Info_Title: "Open Enrollment Information",
    OE_Info_Desc:
        "Learn about the Open Enrollment timeline, application processes, priority placement tiers, and important district deadlines.",
    OE_Info_Btn: "View Enrollment Guidelines →",
    OE_Help_Footer_Title: "Already have a student enrolled in DCSD?",
    OE_Help_Footer_Desc:
        " If your student currently attends a DCSD school, you already have a Parent Portal account. Please log in using your guardian credentials or contact your student's school for assistance.",
    OE_Guardian_No_Students_IT_Help:
        "If you do not see your student(s) and they are currently enrolled in a DCSD school, please contact the IT Support Center at ",
    OE_Notice_Header: "Applying for Open Enrollment?",
    OE_Notice_Begins_Pre: "Open Enrollment for the ",
    OE_Notice_Begins_Mid: " school year will begin on ",
    OE_Notice_Subtext:
        "Once the enrollment window opens, the “Add New Student” button will appear above to submit your application.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Error Messages //////////////////////////
    /// /////////////////////////////////////////////////////////
    Error_UserDetails_Title: "User Details Unavailable",
    Error_UserDetails_Sub: (
        <>
            There was a problem retrieving your account information from our system.
            <br />
            We apologize for the inconvenience.
        </>
    ),
    Error_UserDetails_Sync_Msg:
        "If you are a current DCSD guardian, your user account information may require additional troubleshooting.",
    Error_UserDetails_Contact_Pre: (
        <>
            Please contact the <strong>IT Support Center</strong> at{" "}
            <strong style={{ color: "#0669B3" }}>303-387-0001</strong> for further assistance.
        </>
    )
    /// /////////////////////////////////////////////////////////
};
